import { DataTableContextProvider } from './contexts/DataTableContext';
import { DataTableAdvanced } from './DataTableAdvanced';
import { DataTableSimple } from './DataTableSimple';
import { DATA_TABLE_SIZE, type DataTableSize, type Query } from './types';

type Props = {
    data?: Array<Record<string, unknown>>;
    children: React.ReactNode | Array<React.ReactNode>;
    tbodyRef?: React.RefObject<HTMLTableSectionElement | null>;
    className?: string;
    size?: DataTableSize;
    initialSortQuery?: Query;
};

export const DataTable: React.FC<Props> = ({
    children,
    className,
    data,
    initialSortQuery,
    size = DATA_TABLE_SIZE.DEFAULT,
    tbodyRef,
}) => {
    return (
        <DataTableContextProvider initialSortQuery={initialSortQuery} size={size}>
            {data ? (
                <DataTableSimple className={className} data={data}>
                    {children}
                </DataTableSimple>
            ) : (
                <DataTableAdvanced className={className} tbodyRef={tbodyRef}>
                    {children}
                </DataTableAdvanced>
            )}
        </DataTableContextProvider>
    );
};
